import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';

import ResumeVacancyStepsModal from '../../../components/modals/ResumeVacancyStepsModal';
import CompleteStep from './CompleteStep';
import FailedStep from './FailedStep';
import {candidateHooks} from '../../../api/candidate.api';
import CandidateCommentsModal from './CandidateCommentsModal';
import ComeFailedStep from "./comeFailedStep";
import PdfModal from "../../../components/modals/pdf-modal";
import DeleteCandidate from "../modal/delete-candidate";
import CandidateCard from "../../../components/modals/Candidate-card";
import {ICandidateShort} from "../../../types/candidate/ICandidateShort";

type Props = {
  vacancyId: number;
  resumeId: number;
  candidate:  ICandidateShort
  update: () => void;
  showComments: boolean;
  showCommentsFor: string | undefined;
};

const ResumeOperationList = (props: Props) => {
  const { candidate, vacancyId, resumeId, update, showComments, showCommentsFor } = props;
  const [isOpen, setIsOpen] = useState(!!(showComments && showCommentsFor && Number(showCommentsFor) === resumeId));
  const { data: list = [] } = candidateHooks.useVacancyStepsShort(vacancyId, resumeId)
  const toggleDropdown = () => {
    setIsOpen(prev => !prev);
  };


  const notCompleted = list.filter((m) => !m.complete);

  const firstItem = notCompleted.length > 0 ? notCompleted[0] : undefined;

  const hasSteps = firstItem
      && !firstItem.failed
      && !firstItem.isCome
      && list.length > 0;

  const showCompleteStep = hasSteps && list.some(m => !m.complete);

  return (
    <Dropdown show={isOpen} onToggle={toggleDropdown}>
      <Dropdown.Toggle variant="light" id="dropdown-basic">
        <i className="fa-solid fa-ellipsis-vertical"></i>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <ResumeVacancyStepsModal vacancyId={vacancyId} resumeId={resumeId} updateList={update}/>
        <CandidateCard candidate={candidate} vacancyIds={[vacancyId]}/>
        {hasSteps && (
          <>
            {showCompleteStep && <CompleteStep vacancyId={vacancyId} resumeId={resumeId} update={update} />}
            <FailedStep vacancyId={vacancyId} resumeId={resumeId} update={update} />
            <ComeFailedStep vacancyId={vacancyId} resumeId={resumeId} update={update} />
          </>
        )}
        <CandidateCommentsModal vacancyId={vacancyId} resumeId={resumeId} showComments={showComments} showCommentsFor={showCommentsFor} />
        <PdfModal isDropDown={true} fileId={list && list[0]?.resume?.file}/>
        <DeleteCandidate vacancyId={vacancyId} resumeId={resumeId} update={update} />
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ResumeOperationList;